/**
 * Must stay byte-for-byte in sync with the backend's
 * ContactInfoSanitizer.MaskPlaceholder (HeavyDutyMachineryApi) -- chat messages
 * are masked server-side before they're ever persisted/emitted, so this is how
 * the frontend recognizes a masked message to show its own discreet notice
 * (see MessageThreadPanel). Deliberately not a translation key: the backend
 * never localizes it either, since it's stored as plain persisted message text.
 */
export const CONTACT_INFO_MASK_PLACEHOLDER = '[Información de contacto bloqueada]';
